<template>
  <div class="container">
    <el-form :inline="true">
      <el-form-item>
        <el-button type="info" @click="goBack">返回</el-button>
        <el-button type="primary" @click="addOrUpdateHandle()">新增</el-button>
      </el-form-item>
    </el-form>
    <el-table :data="activitiesReview" border style="width: 100%">
      <el-table-column label="活动时间" align="center" width="300">
        <template slot-scope="scope">
          <span
            >{{ scope.row.activitiesStartTime }} -
            {{ scope.row.activitiesEndTime }}</span
          >
        </template>
      </el-table-column>
      <el-table-column
        prop="activitiesTopic"
        label="名称"
        align="center"
        width="630"
      >
        <template slot-scope="scope">
          <span v-html="showcontent(scope.row.activitiesTopic)"></span>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" width="200">
        <template slot-scope="scope">
          <el-button
            type="primary"
            size="mini"
            plain
            class="btns"
            @click="addOrUpdateHandle(scope.row.id)"
          >
            修改
          </el-button>
          <el-button
            type="primary"
            size="mini"
            plain
            class="btns"
            @click="deleteActivities(scope.row.id)"
          >
            删除
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <add-or-update-review
      ref="addOrUpdateRef"
      @activitiesReviewUpdated="getActivityiesReview"
      v-if="addOrUpdateVisible"
    >
    </add-or-update-review>
  </div>
</template>

<script>
import addOrUpdateReview from "./addOrUpdateReview.vue";
import { showcontent } from "../../utils/method";
export default {
  components: {
    addOrUpdateReview,
  },
  data() {
    return {
      activitiesReview: [],
      addOrUpdateVisible: false,
    };
  },
  mounted() {
    this.getActivityiesReview(); //获取活动总览
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    showcontent,
    //获取活动总览
    async getActivityiesReview() {
      let { data } = await this.$ajaxGet(
        `/activitiesPreview/listActivitiesPreview?id=${this.$route.params.id}`
      );
      console.log(data, "活动总览");
      if (data.code === 0) {
        this.activitiesReview = data.data;
        data.data.forEach((e) => {
          if (e.activitiesStartTime) {
            e.activitiesStartTime = e.activitiesStartTime.split(" ")[0];
          }
          if (e.activitiesEndTime) {
            e.activitiesEndTime = e.activitiesEndTime.split(" ")[0];
          }
        });
      }
    },
    //新增或修改活动总览
    addOrUpdateHandle(id) {
      console.log(this.$route.params.id);
      this.addOrUpdateVisible = true;
      this.$nextTick(() => {
        this.$refs.addOrUpdateRef.init(this.$route.params.id, id);
      });
    },
    // 删除活动总览
    deleteActivities(id) {
      this.$confirm("此操作将永久删除该条目,是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$ajaxGet(
            `/activitiesPreview/deleteActivitiesPreview?id=${id}`
          ).then(({ data }) => {
            console.log(data, 134);
            if (data.code === 0) {
              this.getActivityiesReview();
              this.$message({
                type: "success",
                message: "删除成功!",
              });
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
  },
};
</script>

<style scoped lang='less'>
.container {
  background-color: #fff;
  padding: 20px;
  margin-top: -10px;
}
.btns {
  padding: 5px 7px;
  a {
    color: #409eff;
    &:hover {
      color: #fff;
    }
  }
}
</style>